<template>
    <div class="card-group">
        <template v-for="controller in controllers" class>
            <app-feedback-controller
                v-if="controller.type.includes('FeedbackController')"
                :controller="controller"
                :key="controller.name"
                @setSetpoint="setSetpoint"
            ></app-feedback-controller>
            <app-threshold-controller
                v-else-if="controller.type.includes('ThresholdController')"
                :controller="controller"
                :key="controller.name"
                @setSetpoint="setSetpoint"
            ></app-threshold-controller>
            <app-heat-transfer-controller
                v-else-if="controller.type.includes('HeatTransferController')"
                :controller="controller"
                :key="controller.name"
                @setSetpoint="setSetpoint"
            ></app-heat-transfer-controller>
            <app-controller
                v-else
                :controller="controller"
                @setSetpoint="setSetpoint"
                :key="controller.name"
            ></app-controller>
        </template>
    </div>
</template>

<script>
import Controller from "./Controller.vue";
import FeedbackController from "./controllers/FeedbackController";
import ThresholdController from "./controllers/ThresholdController";
import HeatTransferController from "./controllers/HeatTransferController";
import axios from "axios";

export default {
    data() {
        return {
            controllers: [],
            numberOfContacts: 0,
        };
    },
    created() {
        const title = this.getTitle(this);
        if (title) {
            document.title = title;
        }
    },
    components: {
        appController: Controller,
        appFeedbackController: FeedbackController,
        appThresholdController: ThresholdController,
        appHeatTransferController: HeatTransferController,
    },

    computed: {},

    mounted() {
        this.getControllers();
    },

    methods: {
        getControllers() {
            const app = this;
            return axios
                .get("/master/controller_list")
                .then((res) => {
                    app.controllers = res.data;

                    console.log(res.data);
                    console.log("Controller :" + app.controllers);
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        setSetpoint(e) {
            //const app = this;
            var url = "/" + e.name;
            var data = {
                setpoint: e.setpoint,
            };

            return axios
                .put(url, data, {
                    headers: {
                        Accept: "application/json",
                        "Content-type": "application/json",
                        Authorization:
                            "Bearer W0OEQlXdO8KqXb-WjmJaBA9tZGxCLGQt3oc58qGUKXKysvDP7BSQRLC_ixJXWQgz4jkZptJJuqV8Zam0Hk_sDA6mF2Wh9E9VYjc30NJuMRxdxKCK5k6nMxZqDTNXpMowd8-CIltsdWoP0bdtelY5s505CCEGhud2wBdh4ovRNyigBZsK4vJ-uAPSorVc-cR8XxzXTIbwUgfRCqiHxmpqi_v4SNjVQIxCqHvGVec2x_bJKecu1jS4pSQA4jxB9KsEbbVCw3-ExjS3BC69yuSIaH8SzBzOTpHR2igHbGP2X6zk2s-jVkBRIigENqXiW_eqNBecewpj9-H5zW3pDG4kfw",
                    },
                })
                .then((res) => {
                    this.getControllers();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getTitle(vm) {
            const { title } = vm.$options;
            if (title) {
                return typeof title === "function" ? title.call(vm) : title;
            }
        },
    },
};
</script>